import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Bell } from 'lucide-react';
import { Capacitor } from '@capacitor/core';
import OnboardingLayout from '../../components/onboarding/OnboardingLayout';
import Button from '../../components/ui/Button';

const ONBOARDING_COMPLETED_KEY = 'onboarding_completed';
const NOTIFICATIONS_ENABLED_KEY = 'notifications_enabled';

const NotificationPermission = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const completeOnboarding = (notificationsGranted) => {
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem(ONBOARDING_COMPLETED_KEY, 'true');
      localStorage.setItem(
        NOTIFICATIONS_ENABLED_KEY,
        notificationsGranted ? 'true' : 'false'
      );
    }
    navigate('/', { replace: true });
  };

  const handleEnable = async () => {
    setLoading(true);
    try {
      let granted = false;

      if (Capacitor.isNativePlatform()) {
        // على iOS/Android: استخدم Firebase Messaging مباشرة لتجنب حوار مزدوج
        // registerMobilePush (بعد تسجيل الدخول) سيطلب الإذن ويحفظ التوكن
        // هنا نطلب الإذن فقط مبكراً حتى لا يُفاجأ المستخدم بعد الدخول
        const { FirebaseMessaging } = await import('@capacitor-firebase/messaging');
        const result = await FirebaseMessaging.requestPermissions();
        granted = result.receive === 'granted';
        console.log('[Onboarding] native permission result:', result.receive);
      } else {
        // على الويب فقط: استخدم Notification API العادية
        if (typeof Notification !== 'undefined' && Notification.requestPermission) {
          const permission = await Notification.requestPermission();
          granted = permission === 'granted';
        }
      }

      completeOnboarding(granted);
    } catch (err) {
      console.warn('[Onboarding] permission request failed:', err);
      completeOnboarding(false);
    } finally {
      setLoading(false);
    }
  };

  const handleLater = () => {
    completeOnboarding(false);
  };

  return (
    <OnboardingLayout>
      <motion.div
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
        className="text-center"
      >
        <div className="flex justify-center mb-6">
          <div className="w-20 h-20 rounded-full bg-primary/10 flex items-center justify-center">
            <Bell className="w-10 h-10 text-primary" strokeWidth={2} />
          </div>
        </div>
        <h1 className="text-2xl font-bold text-slate-900 mb-3">
          فعّل الإشعارات
        </h1>
        <p className="text-slate-600 mb-8 leading-relaxed">
          لتصلك إشعارات فورية عند قبول الحجز أو وصول طلبات جديدة.
        </p>
        <div className="flex flex-col gap-3">
          <Button
            onClick={handleEnable}
            disabled={loading}
            className="w-full"
            style={{ backgroundColor: 'var(--color-button)' }}
          >
            {loading ? 'جاري التفعيل...' : 'تفعيل الإشعارات'}
          </Button>
          <Button variant="outline" onClick={handleLater} className="w-full">
            لاحقاً
          </Button>
        </div>
      </motion.div>
    </OnboardingLayout>
  );
};

export default NotificationPermission;
